import { createFileRoute } from '@tanstack/react-router'
import { PitsPage } from '@/features/pits/PitsPage'
import { requireNav } from '@/nav/guard'

export const Route = createFileRoute('/_app/pits')({
  beforeLoad: requireNav('pits'),
  component: PitsPage,
})
